import React, { useContext } from 'react';
import { i18n } from '../../i18n';
import { EmbedGenerator, EmbedGeneratorProps } from '@prezi/viewer-common';
import { DesignPageContext, DesignViewPageModal } from '../../context';
import { glassboxWebJs } from '@prezi/client-logger-module';

export const EmbedGeneratorContainer = (props: { preziOid: string }) => {
    const { setActiveModal } = useContext(DesignPageContext);

    const getEmbedIframeText = (oid: string, _height: string, _width: string) => {
        return `<script async src="https://e.prezicdn.net/v1/design.js"></script>
<div class="prezi-design-embed" data-project-id="${oid}"></div>`;
    };

    const embedProps: EmbedGeneratorProps = {
        oid: props.preziOid,
        getEmbedIframeText,
        onCopy: () => {
            glassboxWebJs.logCopyEmbedCodeToClipboard({ prezi_oid: props.preziOid });
        },
        onCloseModal: () => {
            setActiveModal(DesignViewPageModal.NO_MODAL);
        },
        localizedMessages: {
            headerText: i18n.t`Embed Prezi Design`,
            heightText: i18n.t`Height`,
            widthText: i18n.t`Width`,
            pixelText: i18n.t`pixels`,
            copyButtonText: i18n.t`Copy code to clipboard`,
            copyButtonSuccessText: i18n.t`Copied!`,
            dimensionsTitleText: i18n.t`Dimensions`,
            codeTitleText: i18n.t`Code`,
            responsiveDimensionsText: i18n.t`The embedded view will adjust to its container and will adapt to the viewer's screen size.`,
            learnMoreText: i18n.t`Read more`,
        },
        onlyResponsiveDimensionsAllowed: true,
        learnMoreUrl: 'https://support.prezi.com/hc/articles/360053442394-Embedding-your-Prezi-Design-content',
    };

    return <EmbedGenerator {...embedProps} />;
};
